<div class="ls-tool-return">
  <h5>{{ "lineSetter.tool-returns.pages.selectLineAndToolRequest" | translate }}</h5>
  <div class="ls-return-main-data">
      <div class="return-input-container">
          <label [ngClass]="{'error': !selectedLine && firstNextTried}" for="manufacturing-line">
              {{"lineSetter.toolRequest.stepper.manufacturingLine" | translate }}
          </label>
          <app-dropdown-autocomplete id="manufacturing-line"
                                     [items]="lines"
                                     valueField="id"
                                     displayField="name"
                                     [emptyText]="'lineSetter.tool-returns.stepper.select-line-and-tool-request.panel.line-input.placeholder' | translate"
                                     (selectItem)="onLineChanged($event)">
          </app-dropdown-autocomplete>

      </div>
      <div class="return-input-container"
           [ngClass]="{'disabled': !selectedLine || toolRequests.length === 0}">
          <label [ngClass]="{'error': !selectedToolRequest && firstNextTried}" for="tool-request">
              {{"lineSetter.tool-returns.pages.toolRequest" | translate }}
          </label>
          <app-dropdown-autocomplete id="tool-request"
                                     [items]="toolRequests"
                                     valueField="id"
                                     displayField="name"
                                     [emptyText]="'lineSetter.tool-returns.stepper.select-tools.tool-requests-dropdown.placeholder' | translate"
                                     (selectItem)="onToolRequestChanged($event)">
          </app-dropdown-autocomplete>
      </div>
  </div>
</div>